// src/context/ChatContext.js
import { createContext, useState } from 'react';

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [history, setHistory] = useState([]);
  const [currentPrompt, setCurrentPrompt] = useState('');

  const addChat = (content, type = 'text') => {
    const name = generateTitle(content, type);
    const newChat = { id: Date.now(), name, content, type, date: new Date(), saved: false, archived: false };
    setHistory(prev => [newChat, ...prev]);
  };

  const deleteChat = (id) => {
    setHistory(prev => prev.filter(chat => chat.id !== id));
  };

  const updateChat = (id, updates) => {
    setHistory(prev => prev.map(chat => chat.id === id ? { ...chat, ...updates } : chat));
  };

  const generateTitle = (content, type) => {
    if (type === 'image') return `Image: ${content.slice(0, 30)}`;
    if (type === 'video') return `Video: ${content.slice(0, 30)}`;
    return content.length > 30 ? `${content.slice(0, 30)}...` : content;
  };

  return (
    <ChatContext.Provider value={{ history, addChat, deleteChat, updateChat, currentPrompt, setCurrentPrompt }}>
      {children}
    </ChatContext.Provider>
  );
};
